import Backbone from 'backbone';

export var PmlayerView = Backbone.View.extend({
  initialize: function () {
    this.listenTo(this.model, 'change:isVisible', this.render);
    this.render();
  },

  events: {
    'click [data-pmlayer-close]': 'handleClose',
    'click [data-pmlayer-dismiss]': 'handleDismiss'
  },

  handleClose: function (e) {
    e.preventDefault();
    this.model.setClose();
  },

  handleDismiss: function (e) {
    e.preventDefault();
    this.model.setDismiss();
  },

  render: function () {
    if (this.model.get('isVisible')) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
    return this;
  }
});
